export enum QUESTION_KEY {
  UserSignupPersona = 'user_signup_persona',
  UserGraphQLBackground = 'user_graphql_background',
  UserInitialIntent = 'user_initial_intent',
}

interface SurveyOption {
  label: string;
  value: string;
}

interface SurveyQuestionType {
  label: string;
  name: QUESTION_KEY;
  options: SurveyOption[];
  version: number;
}

interface Survey {
  name: string;
  dbName: string;
  version: number;
  questions: QUESTION_KEY[];
}

export const QUESTION_BANK: Record<QUESTION_KEY, SurveyQuestionType> = {
  [QUESTION_KEY.UserSignupPersona]: {
    label: 'How do you primarily interact with APIs?',
    name: QUESTION_KEY.UserSignupPersona,
    version: 2,
    options: [
      {
        label: 'I use APIs to build client applications',
        value: 'frontendDev',
      },
      {
        label: 'I build and implement APIs',
        value: 'backendDev',
      },
      {
        label: 'I work on API design strategy and architecture',
        value: 'platformLead',
      },
      {
        label: 'I manage / lead teams of engineers who work with APIs',
        value: 'engLeader',
      },
      {
        label: "I'm a student learning how to work with APIs",
        value: 'student',
      },
    ],
  },
  [QUESTION_KEY.UserInitialIntent]: {
    label: 'What is your primary goal today?',
    name: QUESTION_KEY.UserInitialIntent,
    version: 2,
    options: [
      {
        label: 'Manage APIs for an AI use case',
        value: 'mcp',
      },
      {
        label: 'Manage and scale a GraphQL API already on production',
        value: 'manageExistingProd',
      },
      {
        label: 'Build a new GraphQL API for a known use case',
        value: 'buildNew',
      },
      {
        label: 'Set up a demo or template graph to learn GraphQL',
        value: 'exploreDemo',
      },
    ],
  },
  [QUESTION_KEY.UserGraphQLBackground]: {
    label: 'How much have you worked with GraphQL?',
    name: QUESTION_KEY.UserGraphQLBackground,
    version: 1,
    options: [
      {
        label: 'I’m new to GraphQL',
        value: 'gqlNewbie',
      },
      {
        label:
          'I don’t use GraphQL today, but I have experimented with it in the past',
        value: 'gqlBoomerang',
      },
      {
        label: 'I’m comfortable with GraphQL basics',
        value: 'gqlModerate',
      },
      {
        label: 'I’m a go-to GraphQL expert with my team',
        value: 'gqlGuru',
      },
    ],
  },
};

export const SURVEYS: Record<string, Survey> = {
  userProfileSurveyV1: {
    name: 'User Profile',
    dbName: 'user_profile_survey',
    version: 2,
    questions: [
      QUESTION_KEY.UserSignupPersona,
      QUESTION_KEY.UserGraphQLBackground,
      QUESTION_KEY.UserInitialIntent,
    ],
  },
};
